import React, { useState } from "react";
import { Search, Trash2, Eye, ChevronDown, ChevronUp } from "lucide-react";

export default function LogPageone() {
  const [showFilters, setShowFilters] = useState(true);

  const logs = [
    {
      id: 1,
      level: "Information",
      message: "Application started",
      date: "11/04/2025 2:37:42 AM",
    },
    {
      id: 2,
      level: "Information",
      message: "Application started",
      date: "11/04/2025 2:33:50 AM",
    },
    {
      id: 3,
      level: "Information",
      message: "Application started",
      date: "11/04/2025 2:32:55 AM",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-semibold text-gray-800">Log</h1>
        <div className="flex gap-2">
          <button className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1">
            <Trash2 size={14} /> Delete selected
          </button>
          <button className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1">
            <Trash2 size={14} /> Clear log
          </button>
        </div>
      </div>

      {/* Info banner */}
      <div className="bg-blue-50 text-sm text-gray-700 p-3 rounded-md mb-5">
        Have questions or need help? Get dedicated support from the routekart
        team with a guaranteed response within 24 hours.
      </div>

      {/* Search Filters */}
      <div className="bg-white shadow-sm rounded-lg mb-6 border">
        <div
          className="flex justify-between items-center px-4 py-3 border-b cursor-pointer"
          onClick={() => setShowFilters(!showFilters)}
        >
          <h2 className="font-semibold text-gray-700 flex items-center gap-2">
            <Search size={16} /> Search
          </h2>
          {showFilters ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </div>

        {showFilters && (
          <div className="p-4 grid md:grid-cols-4 gap-4">
            <div>
              <label className="text-sm text-gray-600">Created from</label>
              <input
                type="date"
                className="w-full border rounded-md px-2 py-1 mt-1 text-sm"
              />
            </div>
            <div>
              <label className="text-sm text-gray-600">Created to</label>
              <input
                type="date"
                className="w-full border rounded-md px-2 py-1 mt-1 text-sm"
              />
            </div>
            <div>
              <label className="text-sm text-gray-600">Message</label>
              <input
                type="text"
                placeholder="Search message..."
                className="w-full border rounded-md px-2 py-1 mt-1 text-sm"
              />
            </div>
            <div>
              <label className="text-sm text-gray-600">Log level</label>
              <select className="w-full border rounded-md px-2 py-1 mt-1 text-sm">
                <option>All</option>
                <option>Information</option>
                <option>Warning</option>
                <option>Error</option>
              </select>
            </div>
            <div className="md:col-span-4 flex justify-end">
              <button className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-md flex items-center gap-1">
                <Search size={14} /> Search
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Logs Table */}
      <div className="bg-white shadow-sm rounded-lg border overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-700">
          <thead className="bg-gray-100 border-b text-gray-600 uppercase text-xs">
            <tr>
              <th className="p-3">
                <input type="checkbox" />
              </th>
              <th className="p-3">Log level</th>
              <th className="p-3">Short message</th>
              <th className="p-3">Created on</th>
              <th className="p-3 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-b hover:bg-gray-50">
                <td className="p-3">
                  <input type="checkbox" />
                </td>
                <td className="p-3">{log.level}</td>
                <td className="p-3">{log.message}</td>
                <td className="p-3">{log.date}</td>
                <td className="p-3 text-center">
                  <button className="text-blue-600 hover:text-blue-800 flex items-center gap-1 justify-center">
                    <Eye size={14} /> View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer / Pagination */}
        <div className="flex flex-col md:flex-row justify-between items-center p-3 text-sm text-gray-600">
          <div className="flex items-center gap-2 mb-2 md:mb-0">
            <span>Show</span>
            <select className="border rounded-md px-2 py-1 text-sm">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>

          <div className="flex items-center gap-2">
            <button className="px-3 py-1 border rounded-md hover:bg-gray-100">
              Previous
            </button>
            <button className="px-3 py-1 bg-blue-600 text-white rounded-md">
              1
            </button>
            <button className="px-3 py-1 border rounded-md hover:bg-gray-100">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
